import react, { useEffect, useState } from "react";
import "./ExcelUpload.css";

import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import StudentExcelUpload from "./StudentExcelUpload";
import RegularFeeExcelUpload from "./RegularFeeExcelUpload";
import SupplyFeeExcelUpload from "./SupplyFeeExcelUpload";
import FAcultyExcelUpload from "./FacultyExcelUpload";
// import CommiteeExcelupload from "./CommiteeExcelupload";
import CommiteeMemberUpload from "./CommiteeMemberExcelupload";
import CommiteeUpload from "./CommiteeUpload";
import RegulationsAndSyllabus from "./RegulationsSyllabusUpload";
import UploadphotosCommitee from "../GrevienceCommittee/UploadphotosCommitee";
import SingleFacultyUpload from "../Departments/CSE/SingleFacultyUpload";
import CommiteeFunctions from "./CommiteeFunctions";
import AcademicCalendar from './../BranchMenus/AcademicCalendar';
import AcademicCalendarPdf from "./AcademicCalenderPdf"
import PlacementsUpload from "./PlacementsUpload";
const ExcelUploads = () => {
  const [uploadType, setUploadType] = useState("student");
  const navigate = useNavigate();

  console.log("upload type===>", uploadType);
  return (
    <div className="facultyUploadContainer">
      <div className="excelUploadContainer">
        <label>Excel Type</label>
        <select
          onChange={(e) => {
            setUploadType(e.target.value);
          }}
          id="student"
        >
          <option>Please Select</option>
          <option value="student">Student</option>
          <option value="RegularFee">Regular Fee</option>
          {/* <option value="supplyFee">Supply Fee</option> */}
          <option value="Faculty">Faculty Upload</option>
          <option value="Commitee">Committee Upload</option>
          <option value="CommiteeMember">Committee Member</option>
          <option value="CommiteePhoto">Committee Photo upload</option>
          <option value="regulation"> Course Structure Upload</option>
          <option value="one faculty">Add One Faculty Member</option>
          <option value="commiteeFunctions">Committee Functions</option>
          <option value="placementsupload">Placements Upload</option>
          <option value="AcademicCalendarPDFUpload">AcademicCalendar PDF Upload</option>

        </select>
      </div>
      <div className="excelContainers">
        {uploadType === "student" && <StudentExcelUpload />}
        {uploadType === "RegularFee" && <RegularFeeExcelUpload />}
        {uploadType === "supplyFee" && <SupplyFeeExcelUpload />}
        {uploadType === "Faculty" && <FAcultyExcelUpload />}
        {uploadType === "Commitee" && <CommiteeUpload />}
        {uploadType === "CommiteeMember" && <CommiteeMemberUpload />}
        {uploadType === "CommiteePhoto" && <UploadphotosCommitee />}
        {uploadType === "regulation" && <RegulationsAndSyllabus />}
        {uploadType === "one faculty" && <SingleFacultyUpload />}
        {uploadType === "commiteeFunctions"&& <CommiteeFunctions/>}
        {uploadType === "placementsupload" && <PlacementsUpload/>}
        {uploadType === "AcademicCalendarPDFUpload" && <AcademicCalendarPdf/>}

      </div>
    </div>
  );
};
export default ExcelUploads;
